/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Secure_AssetInputs */

const en_secure_asset = /** @type {(inputs: Secure_AssetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Secure Asset`)
};

const id_secure_asset = /** @type {(inputs: Secure_AssetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aset Aman`)
};

/** @type {(inputs: Secure_AssetInputs) => LocalizedString} */
const es_secure_asset = en_secure_asset;

/** @type {(inputs: Secure_AssetInputs) => LocalizedString} */
const fr_secure_asset = en_secure_asset;

/** @type {(inputs: Secure_AssetInputs) => LocalizedString} */
const de_secure_asset = en_secure_asset;

/** @type {(inputs: Secure_AssetInputs) => LocalizedString} */
const ja_secure_asset = en_secure_asset;

/** @type {(inputs: Secure_AssetInputs) => LocalizedString} */
const zh_secure_asset = en_secure_asset;

/** @type {(inputs: Secure_AssetInputs) => LocalizedString} */
const ar_secure_asset = en_secure_asset;

/** @type {(inputs: Secure_AssetInputs) => LocalizedString} */
const it_secure_asset = en_secure_asset;

/** @type {(inputs: Secure_AssetInputs) => LocalizedString} */
const ru_secure_asset = en_secure_asset;

/** @type {(inputs: Secure_AssetInputs) => LocalizedString} */
const pt_secure_asset = en_secure_asset;

/** @type {(inputs: Secure_AssetInputs) => LocalizedString} */
const ko_secure_asset = en_secure_asset;

/**
* | output |
* | --- |
* | "Secure Asset" |
*
* @param {Secure_AssetInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const secure_asset = /** @type {((inputs?: Secure_AssetInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Secure_AssetInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_secure_asset(inputs)
	if (locale === "es") return es_secure_asset(inputs)
	if (locale === "fr") return fr_secure_asset(inputs)
	if (locale === "de") return de_secure_asset(inputs)
	if (locale === "ja") return ja_secure_asset(inputs)
	if (locale === "zh") return zh_secure_asset(inputs)
	if (locale === "ar") return ar_secure_asset(inputs)
	if (locale === "id") return id_secure_asset(inputs)
	if (locale === "it") return it_secure_asset(inputs)
	if (locale === "ru") return ru_secure_asset(inputs)
	if (locale === "pt") return pt_secure_asset(inputs)
	return ko_secure_asset(inputs)
});